import React, { useState, useEffect } from "react";
import axios from "axios";
import AnnouncementComposer from "./AnnouncementComposer";

const ManageAnnouncements = () => {
    const [announcements, setAnnouncements] = useState([]);
    const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);

    useEffect(() => {
        fetchAnnouncements();
    }, []);

    const fetchAnnouncements = async () => {
        try {
            const response = await axios.get("/api/announcements/admin", {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            });
            setAnnouncements(response.data);
        } catch (error) {
            console.error("Error fetching announcements:", error);
        }
    };

    const handleDeleteAnnouncement = async (id) => {
        try {
            await axios.delete(`/api/announcements/${id}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            });
            setAnnouncements((prev) => prev.filter((a) => a._id !== id));
        } catch (error) {
            console.error("Error deleting announcement:", error);
        }
    };

    return (
        <div>
            <h2 className="text-2xl font-bold mb-4">Manage Announcements</h2>
            {selectedAnnouncement ? (
                <AnnouncementComposer
                    existingAnnouncement={selectedAnnouncement}
                    onClose={() => setSelectedAnnouncement(null)}
                    onRefresh={fetchAnnouncements}
                    onCancel={() => setSelectedAnnouncement(null)}
                />
            ) : (
                <>
                    <button
                        onClick={() => setSelectedAnnouncement({})} // Initialize as null for Create Mode
                        className="bg-green-500 text-white px-4 py-2 rounded mb-4"
                    >
                        Create New Announcement
                    </button>
                    <ul className="space-y-4">
                        {announcements.map((announcement) => {
                            const startDate = announcement.scheduleDate
                                ? new Date(announcement.scheduleDate).toLocaleString()
                                : "Not scheduled";
                            const expireDate = announcement.expireDate
                                ? new Date(announcement.expireDate).toLocaleString()
                                : "No expiration";

                            return (
                                <li key={announcement._id} className="border p-4 rounded bg-gray-100">
                                    <h3 className="font-bold">{announcement.title}</h3>
                                    <p>{announcement.description}</p>
                                    {announcement.imageUrl && (
                                        <img
                                            src={announcement.imageUrl}
                                            alt={announcement.title}
                                            className="my-4 rounded"
                                        />
                                    )}
                                    <p className="text-sm">
                                        <strong>Starts:</strong> {startDate}
                                    </p>
                                    <p className="text-sm">
                                        <strong>Expires:</strong> {expireDate}
                                    </p>
                                    <p className="text-sm">
                                        <strong>Status:</strong> {announcement.enabled ? "Enabled" : "Disabled"}
                                    </p>
                                    <div className="mt-4">
                                        <button
                                            onClick={() => setSelectedAnnouncement(announcement)}
                                            className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
                                        >
                                            Edit
                                        </button>
                                        <button
                                            onClick={() => handleDeleteAnnouncement(announcement._id)}
                                            className="bg-red-500 text-white px-4 py-2 rounded"
                                        >
                                            Delete
                                        </button>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </>
            )}
        </div>
    );
};

export default ManageAnnouncements;
